import ApplicationController from "./application_controller";

export default class extends ApplicationController {
static targets = [ "showFormBtn", "form" ]

  expandFilterForm() {
    this.showFormBtnTarget.style.display = "none";
    this.formTarget.classList.add("expand-down");
  }
}